import React, { useMemo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Skeleton from "@mui/material/Skeleton";
import SearchInput from "../../../common/SearchInputField";
import { FilterChipCloseIcon } from "../Customers/customersFilterUiShared";
import CustomerToolbarFilterDropdown from "../Customers/CustomerToolbarFilterDropdown";

export default function AgentToolbar({
  searchQuery,
  onSearchChange,
  roleFilters,
  teamFilters = [],
  onRoleFiltersChange,
  onTeamFiltersChange,
  onClearAll,
  roleOptions = [],
  teamOptions = [],
  optionsLoading = false,
}) {
  const chips = useMemo(() => {
    const roleChips = roleFilters.map((v) => {
      const opt = roleOptions.find((o) => o.value === v);
      return { key: `role-${v}`, label: opt?.label || v, type: "role", value: v };
    });
    const teamChips = (teamFilters || []).map((v) => {
      const opt = teamOptions.find((o) => o.value === v);
      return { key: `team-${v}`, label: opt?.label || v, type: "team", value: v };
    });
    return [...roleChips, ...teamChips];
  }, [roleFilters, teamFilters, roleOptions, teamOptions]);

  const removeChip = (chip) => {
    if (chip.type === "role") onRoleFiltersChange(roleFilters.filter((v) => v !== chip.value));
    else if (chip.type === "team") onTeamFiltersChange(teamFilters.filter((v) => v !== chip.value));
  };

  return (
    <Box sx={{ px: "24px", pt: "24px", pb: chips.length ? 1 : 3 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
        <Box sx={{ width: 296, flex: "0 0 296px" }}>
          <SearchInput
            placeholder="Search agents..."
            value={searchQuery}
            className="SearchInputField-article"
            onChange={(e) => onSearchChange(e.target.value)}
            iconPosition="left"
            iconGap={8}
            style={{ width: 296 }}
            inputStyle={{ width: 296 }}
            noTitle
            iconVariant="people"
          />
        </Box>
        {optionsLoading ? (
          <>
            <Skeleton variant="rounded" width={88} height={40} sx={{ borderRadius: "8px" }} />
          </>
        ) : (
          <CustomerToolbarFilterDropdown
            label="Role"
            placeholder="Search role"
            options={roleOptions}
            selected={roleFilters}
            onChange={onRoleFiltersChange}
          />
        )}
      </Box>
      {chips.length > 0 && (
        <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 1, mt: 1.5 }}>
          {chips.map((chip) => (
            <Box
              key={chip.key}
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 0.75,
                px: 1.5,
                py: 0.5,
                borderRadius: "20px",
                border: "1px solid #C5CED6",
                background: "#F9FAFA",
                boxShadow: "0 1px 2px 0 rgba(6, 21, 34, 0.05)",
              }}
            >
              <Typography sx={{ fontSize: 14, color: "#405261", fontFamily: "Inter" }}>
                {chip.label}
              </Typography>
              <Box
                component="button"
                type="button"
                onClick={() => removeChip(chip)}
                sx={{ border: "none", background: "transparent", p: 0, display: "flex", cursor: "pointer" }}
              >
                <FilterChipCloseIcon style={{ width: 16, height: 16, display: "block" }} />
              </Box>
            </Box>
          ))}
          <Button
            onClick={onClearAll}
            sx={{
              height: 32,
              borderRadius: "8px",
              border: "1px solid #D5DCE1",
              background: "#FFF",
              color: "#405261",
              textTransform: "none",
              fontFamily: "Inter",
              fontSize: 14,
              "&:hover": { background: "#FFF", borderColor: "#C5CED6" },
            }}
          >
            Clear All
          </Button>
        </Box>
      )}
    </Box>
  );
}
